import { Badge } from '../../components';
import { 
  HiCheck, 
  HiClock, 
  HiExclamationTriangle, 
  HiInformationCircle,
  HiXMark,
  HiUser 
} from 'react-icons/hi2';

export const BadgesPage = () => {
  const variants = ['success', 'warning', 'error', 'danger', 'info', 'default'] as const;
  const styles = ['solid', 'outline', 'ghost'] as const;
  const sizes = ['sm', 'md', 'lg'] as const;

  return (
    <div className="max-w-6xl mx-auto space-y-8">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">
          Componente Badge
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Badges com diferentes variantes, estilos e tamanhos
        </p>
      </div>

      {/* Exemplos por Estilo */}
      <div className="space-y-8">
        {styles.map((style) => (
          <div key={style} className="bg-white dark:bg-neutral-800 rounded-lg shadow-lg border border-gray-200 dark:border-neutral-700 p-6">
            <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4 capitalize">
              Estilo: {style}
            </h3>
            
            <div className="space-y-4">
              {variants.map((variant) => (
                <div key={variant} className="flex items-center space-x-4">
                  <div className="w-20 text-sm font-medium text-gray-700 dark:text-gray-300 capitalize">
                    {variant}:
                  </div>
                  <div className="flex items-center space-x-3">
                    {sizes.map((size) => (
                      <Badge 
                        key={size}
                        variant={variant}
                        style={style}
                        size={size}
                      >
                        {size.toUpperCase()}
                      </Badge>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Exemplos de Uso no Sidebar */}
      <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-lg border border-gray-200 dark:border-neutral-700 p-6">
        <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Exemplos de Uso (Como no Sidebar)
        </h3>
        
        <div className="space-y-4">
          <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-neutral-700/50 rounded-lg border border-gray-200/50 dark:border-neutral-600/50">
            <div className="flex items-center space-x-3">
              <div className="w-5 h-5 bg-blue-500 dark:bg-blue-600 rounded"></div>
              <span className="text-gray-900 dark:text-gray-100">Todas as Demandas</span>
            </div>
            <Badge variant="info" style="solid" size="sm">24</Badge>
          </div>

          <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-neutral-700/50 rounded-lg border border-gray-200/50 dark:border-neutral-600/50">
            <div className="flex items-center space-x-3">
              <div className="w-5 h-5 bg-yellow-500 dark:bg-yellow-600 rounded"></div>
              <span className="text-gray-900 dark:text-gray-100">Recebidas</span>
            </div>
            <Badge variant="warning" style="solid" size="sm">5</Badge>
          </div>

          <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-neutral-700/50 rounded-lg border border-gray-200/50 dark:border-neutral-600/50">
            <div className="flex items-center space-x-3">
              <div className="w-5 h-5 bg-green-500 dark:bg-green-600 rounded"></div>
              <span className="text-gray-900 dark:text-gray-100">Enviadas</span>
            </div>
            <Badge variant="success" style="solid" size="sm">8</Badge>
          </div>

          <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-neutral-700/50 rounded-lg border border-gray-200/50 dark:border-neutral-600/50">
            <div className="flex items-center space-x-3">
              <div className="w-5 h-5 bg-gray-500 dark:bg-gray-600 rounded"></div>
              <span className="text-gray-900 dark:text-gray-100">Observáveis</span>
            </div>
            <Badge variant="default" style="outline" size="sm">3</Badge>
          </div>
        </div>
      </div>

      {/* Exemplos com Ícones */}
      <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-lg border border-gray-200 dark:border-neutral-700 p-6">
        <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Badges com Ícones
        </h3>
        
        <div className="space-y-4">
          <div className="flex items-center space-x-4">
            <div className="w-20 text-sm font-medium text-gray-700 dark:text-gray-300">
              Success:
            </div>
            <div className="flex items-center space-x-3">
              <Badge variant="success" style="solid" size="sm" icon={<HiCheck className="w-3 h-3" />}>
                Solucionada
              </Badge>
              <Badge variant="success" style="outline" size="md" icon={<HiCheck className="w-4 h-4" />}>
                Finalizada
              </Badge>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="w-20 text-sm font-medium text-gray-700 dark:text-gray-300">
              Warning:
            </div>
            <div className="flex items-center space-x-3">
              <Badge variant="warning" style="solid" size="sm" icon={<HiClock className="w-3 h-3" />}>
                Em Atribuição
              </Badge>
              <Badge variant="warning" style="outline" size="md" icon={<HiExclamationTriangle className="w-4 h-4" />}>
                Aguardando
              </Badge>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="w-20 text-sm font-medium text-gray-700 dark:text-gray-300">
              Error:
            </div>
            <div className="flex items-center space-x-3">
              <Badge variant="error" style="solid" size="sm" icon={<HiXMark className="w-3 h-3" />}>
                Recusada
              </Badge>
              <Badge variant="error" style="outline" size="md" icon={<HiExclamationTriangle className="w-4 h-4" />}>
                Errada
              </Badge>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="w-20 text-sm font-medium text-gray-700 dark:text-gray-300">
              Info:
            </div>
            <div className="flex items-center space-x-3">
              <Badge variant="info" style="solid" size="sm" icon={<HiUser className="w-3 h-3" />}>
                Atribuída
              </Badge>
              <Badge variant="info" style="outline" size="md" icon={<HiInformationCircle className="w-4 h-4" />}>
                Em Progresso
              </Badge>
            </div>
          </div>
        </div>
      </div>

      {/* Código de Exemplo */}
      <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-lg border border-gray-200 dark:border-neutral-700 p-6">
        <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Como Usar
        </h3>
        
        <div className="bg-gray-900 dark:bg-neutral-950 text-gray-100 rounded-lg p-4 overflow-x-auto border border-gray-700 dark:border-neutral-600">
          <pre className="text-sm">
{`import { Badge } from '../components/Badge';
import { HiCheck, HiClock } from 'react-icons/hi2';

// Básico
<Badge>Default</Badge>

// Com variantes
<Badge variant="success">Sucesso</Badge>
<Badge variant="warning">Atenção</Badge>
<Badge variant="error">Erro</Badge>
<Badge variant="danger">Perigo</Badge>
<Badge variant="info">Informação</Badge>

// Com ícones
<Badge variant="success" style="solid" icon={<HiCheck className="w-4 h-4" />}>
  Solucionada
</Badge>

<Badge variant="warning" style="outline" icon={<HiClock className="w-4 h-4" />}>
  Em Atribuição
</Badge>

// Com tamanhos
<Badge size="sm">Pequeno</Badge>
<Badge size="md">Médio</Badge>
<Badge size="lg">Grande</Badge>`}
          </pre>
        </div>
      </div>
    </div>
  );
};
